import Vue from 'vue'
import api from 'api'

const state = {
	templates: [],
	currentTemplate: {
		title: "",
		nbPatients: 10,
		explanations: {
			"FIRST_STEP": "",
			"CRITIC_STEP": "",
			"SECOND_STEP": "",
			"SATISFACTION_SURVEY": ""
		},
		satisfactionSurvey: 'OPTIONAL',
		criterias: [],
		surveyQuestions: [],
		instances: []
	},
	deletedCriterias: [],
	deletedQuestions: [],
	instanceId: 58,
	templateSessions: [],
	sessionDetail: [],
	templateIdToDuplicate: [],
	templateLabelToDuplicate: [],
	modalDuplicateTemplate: false,
	modalStatisticsUser: false,
};

const getters = {
};

const mutations = {
	INIT_TEMPLATE_LIST(state, templates)  {
		state.templates = templates;
	},
	INIT_CURRENT_TEMPLATE(state, template)  {
		state.currentTemplate = template;
	},
	INIT_SESSIONS_TEMPLATE(state, sessions) {
			state.templateSessions = sessions;
	},
	INIT_SESSION(state, sessionDetail) {
			state.sessionDetail = sessionDetail;
	},
	CURRENT_TEMPLATE_UPDATED(state, {key, key2, templateData})	{
		// console.log("key : " + key);
		// console.log("key2 : " + key2);
		// console.log("data : ", templateData);
		if (!key && !key2)	{
			state.currentTemplate = templateData;
		}
		else if (key && !key2)	{
			Vue.set(state.currentTemplate, key, templateData);
		}
		else if (key && key2)	{
			Vue.set(state.currentTemplate[key], key2, templateData);
		}
	},
	DELETED_CRITERIAS_UPDATED(state, criteriaId)	{
		state.deletedCriterias.push(criteriaId);
	},
	DELETED_QUESTIONS_UPDATED(state, questionId)	{
		state.deletedQuestions.push(questionId);
	},
	DELETED_CRITERIAS_RESET(state, criteriaId)	{
		state.deletedCriterias = [];
	},
	DELETED_QUESTIONS_RESET(state, questionId)	{
		state.deletedQuestions = [];
	},
	DISPLAY_MODAL_DUPLICATE_TEMPLATE(state, newStatus) {
		state.modalDuplicateTemplate = newStatus;
	},
	TEMPLATE_ID_TO_DUPLICATE(state, id) {
		state.templateIdToDuplicate = id;
	},
	TEMPLATE_LABEL_TO_DUPLICATE(state, label) {
		state.templateLabelToDuplicate = label;
	}
};

const actions = {
	createTemplate({rootState}, {newTemplate, callbacks})	{
		api.createTemplate(rootState, newTemplate, callbacks);
	},
	updateTemplate({rootState}, {newTemplate, callbacks})	{
		api.updateTemplate(rootState, newTemplate, callbacks);
	},
	getTemplateList({rootState}, {page = 1, callbacks})	{
        api.getTemplateList(rootState, page, callbacks);
    },
    getTemplate({rootState}, {templateId, callbacks})	{
    	api.getTemplate(rootState, templateId, callbacks);
    },
    getDefaultTemplate({rootState}, callbacks)	{
    	api.getDefaultTemplate(rootState, callbacks);
    },
    duplicateTemplate({rootState}, {templateId, targetId, callbacks})	{
    	api.duplicateTemplate(rootState, templateId, targetId, callbacks);
    },
	createCriteria({rootState}, {templateId, newCriteria, position, callbacks})	{
		api.createCriteria(rootState, templateId, newCriteria, position, callbacks);
	},
	updateCriteria({rootState}, {templateId, newCriteria, position, callbacks})	{
		api.updateCriteria(rootState, templateId, newCriteria, position, callbacks);
	},
	deleteCriteria({rootState}, {criteriaId, callbacks})	{
		api.deleteCriteria(rootState, criteriaId, callbacks);
	},
	createQuestion({rootState}, {templateId, newQuestion, position, callbacks})	{
		api.createQuestion(rootState, templateId, newQuestion, position, callbacks);
	},
	updateQuestion({rootState}, {templateId, newQuestion, position, callbacks})	{
		api.updateQuestion(rootState, templateId, newQuestion, position, callbacks);
	},
	deleteQuestion({rootState}, {questionId, callbacks})	{
		api.deleteQuestion(rootState, questionId, callbacks);
	},
	setTargetTemplate({rootState}, {templateId, targetId, callbacks})	{
		api.setTargetTemplate(rootState, templateId, targetId, callbacks);
	},
	getTargetTemplates({rootState}, {onlyEnabled, callbacks})	{
		api.getTargetTemplates(rootState, onlyEnabled, callbacks);
	},
    getParentsTargetInstance({rootState}, {templateId, callbacks}) {
        api.getParentsTargetInstance(rootState, templateId, callbacks);
    },
    getParentTargetInstance({rootState}, {parentTargetInstanceId, callbacks}) {
        api.getParentTargetInstance(rootState, parentTargetInstanceId, callbacks);
    },
    updateParentTargetInstance({rootState}, {parentTargetInstanceId, newParentTargetInstance, callbacks}) {
        api.updateParentTargetInstance(rootState, parentTargetInstanceId, newParentTargetInstance, callbacks);
    }
};

export default {
  state,
  getters,
  mutations,
  actions
};
